import React from "react";
import { useTranslation } from "react-i18next";
import "./Progress.scss";
import {illustration, techStack, leadershipStack, codingPhilosophyStack, crossPlatformStack, appPublishingStack} from "../../portfolio";
import {Fade} from "../../components/FadeReveal/FadeReveal";
import Build from "../../assets/lottie/build";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";

export default function StackProgress() {
  const { t } = useTranslation();
  
  // Array of gradient class names for professional colors
  const gradientClasses = ['gradient-1', 'gradient-2', 'gradient-3', 'gradient-4', 'gradient-5', 'gradient-6', 'gradient-7', 'gradient-8'];
  
  // Function to get a random gradient class
  const getRandomGradient = () => {
    return gradientClasses[Math.floor(Math.random() * gradientClasses.length)];
  };
  
  // Force use the correct data from portfolio.js
  const correctTechStack = {
    viewSkillBars: true,
    experience: [
      {
        Stack: "iOS Development",
        progressPercentage: "80%"
      },
      {
        Stack: "Swift", 
        progressPercentage: "90%"
      },
      {
        Stack: "Objective-C",
        progressPercentage: "70%"
      },
      {
        Stack: "UIKit",
        progressPercentage: "90%"
      },
      {
        Stack: "SwiftUI",
        progressPercentage: "70%"
      }
    ]
  };

  const renderSkillCard = (skillData, title, icon) => (
    <div className="skills-card" key={title}>
      <div className="skills-card-header">
        <span className="skills-card-icon">{icon}</span>
        <h3 className="skills-card-title">{title}</h3>
      </div>
      {skillData.experience.map((exp, i) => {
        const progressStyle = {
          width: exp.progressPercentage
        };
        const gradientClass = getRandomGradient();
        return (
          <div key={i} className="skill">
            <p>{exp.Stack}</p>
            <div className="meter">
              <span style={progressStyle} className={gradientClass}></span>
            </div>
          </div>
        );
      })}
    </div>
  );
  
  console.log("Original techStack:", techStack);
  console.log("Using correctTechStack:", correctTechStack);
  
  if (correctTechStack.viewSkillBars) {
    return (
      <div className="skills-main-container">
        <Fade>
          <div className="skills-header-section">
            <h1 className="skills-heading">{t('skillsExpertise.title')}</h1>
            <p className="skills-subtitle">{t('skillsExpertise.subtitle')}</p>
          </div>

          {/* Row 1: iOS card + decorative animation */}
          <div className="skills-container">
            <div className="skills-bar">
              {renderSkillCard(correctTechStack, t('skillsExpertise.iosDevelopment'), '📱')}
            </div>
            <div className="skills-image skills-lottie-hide">
              {illustration.animated ? (
                <DisplayLottie animationData={Build} />
              ) : (
                <img alt="Skills" src={require("../../assets/images/skill.svg")} />
              )}
            </div>
          </div>

          {/* Remaining 4 skill cards in a responsive 2-col grid */}
          <div className="skills-cards-grid">
            {renderSkillCard(leadershipStack, t('skillsExpertise.leadership'), leadershipStack.icon)}
            {renderSkillCard(codingPhilosophyStack, t('skillsExpertise.philosophy'), codingPhilosophyStack.icon)}
            {renderSkillCard(crossPlatformStack, t('skillsExpertise.crossPlatform'), crossPlatformStack.icon)}
            {renderSkillCard(appPublishingStack, t('skillsExpertise.appPublishing'), appPublishingStack.icon)}
          </div>
        </Fade>
      </div>
    );
  }
  return null;
}
